export default __webpack_public_path__ + "static/media/bloxberg_logo.736b24da.png";